import DumbbellSvg from '@assets/images/svg/dumbbell.svg';
import React from 'react';
import { View } from 'react-native';

export interface DumbbellIconProps {
    size?: number;
    color?: string;
}

export function DumbbellIcon({ size = 24, color = '#4D4D4D' }: DumbbellIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <DumbbellSvg width={size} height={size} color={color} />
        </View>
    );
}

export default DumbbellIcon;
